import { ThrowStmt } from '@angular/compiler';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatProductCategoryModel } from 'src/app/model/cat-product-category.model';
import { ComProductEmployeeJobModel } from 'src/app/model/com-product-employee-job.model';
import { CatSchemaModel } from 'src/app/model/other-catalogs-models';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { ComProductEmployeeJobService } from 'src/oldApp/services/com-product-employee-job.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';

@Component({
  selector: 'app-modal-sc-product-employee-job',
  templateUrl: './modal-sc-product-employee-job.component.html',
  styleUrls: ['./modal-sc-product-employee-job.component.css']
})
export class ModalScProductEmployeeJobComponent implements OnInit {
  @Input() configuration:any;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=1;
  public formIsLocked:boolean=false;
  public selectedSchema:CatSchemaModel=new CatSchemaModel();
  public selectedProductCategory:CatProductCategoryModel=new CatProductCategoryModel();
  public commission:number=null;
  public active:boolean=true;

  // catalogos
  public schemaCatalog:CatSchemaModel[]=[];
  public productCategoryCatalog:CatProductCategoryModel[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  ////////////////
  constructor(
    private comProductEmployeeJobService:ComProductEmployeeJobService,
    private otherCatalogsService:OtherCatalogsService,
    private catProductCategoryService:CatCategoryProductService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    console.log(this.configuration)
    this.getCatalogs();
  }

  //
  updateSchema=()=> {
    console.log(this.selectedSchema)
    this.selectedProductCategory=new CatProductCategoryModel();
    this.commission=null;
  }
  updateProductCategory=()=> {}
  updateCommission=e=> this.commission=Number(e);
  toggleActive=()=> this.active=!this.active;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.schemaError()) errors.push('Necesita seleccionar un esquema.');
    if(this.productCategoryError()) errors.push('Necesita seleccionar una categoría.');
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.comProductEmployeeJobService.save(this.configuration)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  schemaError=()=> !this.selectedSchema || !this.selectedSchema.commissionSchemaId;
  productCategoryError=()=> this.selectedSchema.commissionSchemaId===3 && (!this.selectedProductCategory || !this.selectedProductCategory.productCategoryId);
  commissionError=()=> this.selectedSchema.commissionSchemaId===5 && (this.commission!==0 && ! this.commission);

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.otherCatalogsService.getListSchema(),
      this.catProductCategoryService.getAllActive()
    )
    .pipe(
      tap(([schemaResp, catProdResp]:[any, any])=> {
        if(schemaResp && catProdResp) {
          this.schemaCatalog=schemaResp;
          this.productCategoryCatalog=catProdResp;

          // seleccionar valores
          this.selectedSchema.commissionSchemaId=this.schemaCatalog.find(sc=> sc.commissionSchemaId===this.configuration.schemaId).commissionSchemaId;
          this.selectedProductCategory.productCategoryId=this.productCategoryCatalog.find(cat=> cat.productCategoryId===this.configuration.productCategoryId).productCategoryId;
          this.commission=this.configuration.commission;
          this.active=this.configuration.activeId;

          // mostrar pagina
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
      })
    )
    .subscribe();
  }
}